// src/hooks/useLogout.js
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { clearUser } from "../redux/slices/AuthUser";
import { setAlertDetails } from "../redux/slices/AlertDetailsSlice";
import axiosInstance from "../axios/axiosInstance";

const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logout = useCallback((message, clearPathHistory, type = "success") => {
    dispatch(clearUser());
    localStorage.removeItem("token");// Remove token
    localStorage.removeItem("productSaved");// Remove saved products
    if (clearPathHistory) {
      localStorage.removeItem("pathHistory");// Remove path history
    }
    // Clear httpOnly auth cookie via backend
    axiosInstance.post("/user/logout").catch(() => {});
    dispatch(setAlertDetails({ type, message }));
    navigate("/", { replace: true });
  }, [dispatch, navigate]);

  return logout;
};

export default useLogout;
